import analytics from "web/script/analytics/analytics";
import { ProductBuyOptionsSerializer } from "web/types/serializers";

export const baseAffiliateAnalyticsConfig = (
    mainBuyOption: ProductBuyOptionsSerializer,
    productId: string
) =>
    ({
        href: mainBuyOption.affiliate_url,
        eventCategory: "oos-product-hero",
        eventAction: "click",
        eventCustomData: {
            buy_option_id: mainBuyOption.link_id.toString(),
            product_id: productId,
            retailer_slug: mainBuyOption.retailer_slug,
        },
    } as const);

export const sendAnalyticsEvent = (
    category: string,
    action: string,
    label: string,
    customData?: Record<string, any>
): void => {
    analytics.event(
        category,
        action,
        label,
        action !== "click", // nonInteraction
        customData, // customData
        "", // subType
        {}, // checkoutData
        [],
        false,
        false // itemData
    );
};
